<template>
  <div :class="{ ['v-hr']: true, [type]: true }" :style="_styleObject"></div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VHr", {
  props: {
    type: VueTypes.oneOf(["primary", "secondary", "tertiary", "dark"]).def(
      "dark"
    ),

    color: VueTypes.string,
    height: VueTypes.number.def(2)
  },

  computed: {
    _styleObject() {
      const initialObject = { height: this.height + "px" };

      if (!this.color) {
        return initialObject;
      }

      return { ...initialObject, background: this.color };
    }
  }
});
</script>

<style lang="scss" scoped>
@include mainColorBgPaletteClasses();

.v-hr {
  width: 100%;
  margin: 15px 0;
}
</style>
